import { connect } from "react-redux";

import ChangePassword, { IChangePasswordActions } from "./change-password";
import { changePassword } from "../user.actions";

export default connect(
  null,
  (dispatch): IChangePasswordActions => {
    return {
      changePassword: (oldPassword: string, newPassword: string) => {
        dispatch(changePassword(oldPassword, newPassword));
      }
    };
  }
)(ChangePassword);
